<template>
<!-- 定金合同 -->
    <div class="deposit-contract">
        <el-table
            border
            ref="tableData"
            :data="tableData"
            v-loading="loading"
            style="width: 100%"
            @row-click="clickRow"
            @selection-change="handleSelectChange">
            <el-table-column type="selection" width="30px"></el-table-column>
            <el-table-column prop="createdAt" :label="$t('Contract.charge_date')" />
            <el-table-column prop="storeName" :label="$t('Common.store')" />
            <el-table-column :label="$t('Member.name2')">
                <template slot-scope="{row}">
                    <span
                        @click="handleUser(row.clientId)"
                        class="task-workers cursor-pointer">
                        {{ row.clientName }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="clientGender" :label="$t('Common.gender')"></el-table-column>
            <el-table-column prop="clientPhone" :label="$t('Common.telephone_number')"></el-table-column>
            <el-table-column prop="prepayStatus" :label="$t('Reception.Fourth.status')"></el-table-column>
            <el-table-column prop="amt" :label="$t('Charge.deposit_amount')"></el-table-column>
            <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler2')"></el-table-column>
            <el-table-column prop="receiverStaffNickname" :label="$t('Sell.Pay.people')"></el-table-column>
            <el-table-column prop="expiredAt" :label="$t('Charge.expiration_date')"></el-table-column>
            <el-table-column prop="remark" :label="$t('Common.remark')"></el-table-column>
            <el-table-column prop="usedAt" :label="$t('Charge.use_date')"></el-table-column>
            <el-table-column prop="usedContractType" :label="$t('Charge.use_contract_type')"></el-table-column>
            <el-table-column prop="usedContractNum" :label="$t('Charge.use_contract_number')"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            style="margin-top: 15px;"
            v-if="tableData && tableData.length"
            class="text-right"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>
        <!-- 入会/续会 -->
        <mshp-contract-form ref="mspContract" :type="type" :isDeposit="true"/>
        <!-- 买私教/买储值卡 -->
        <new-contract
            @close="visible = false"
            :infoType="infoType"
            :data="client"
            :contractNum="num"
            v-if="visible"
            ref="newContract"
            :activeName="activeName"
            :contract="contract"
            :isDeposit="true"/>
        <!-- 增加定金金额 & 定金延期 -->
        <handle-cherge ref="monday" @fetchData="fetchData" />
    </div>
</template>
<script>
import handleUser from '@/mixins/handleUser.js';
import MshpContractForm from '@/components/Dialog/Client/MshpContractForm';
import NewContract from '@/components/Dialog/Client/NewContract';
import HandleCherge from '@/components/Dialog/Sell/HandleCherge';

export default {
    name: 'depositContract',
    props: ['activeName', 'date', 'form'],
    components: {
        MshpContractForm,
        NewContract,
        HandleCherge,
    },
    mixins: [handleUser],
    data() {
        return {
            contract: {name: ''},
            type: '',
            contracts: [],
            tableData: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
            visible: false,
            infoType: null,
            client: null,
            loading: false,
            num: null,
        };
    },
    watch: {
        activeName(val) {
            if (val === 'subscription') this.fetchData();
        },
    },
    created() {
        if (this.activeName === 'subscription') this.fetchData();
    },
    methods: {
        // 不传form仅刷新页面
        flush() {},
        fetchData() {
            // contractNum - 合同编号
            // contractSalesStaffId - 销售员工 id
            // createdAtEnd createdAtStart
            // keyword storeId
            // prepayStatusCode 定金状态：1-有效,2-过期,3-已用,4-无效
            let form = Object.assign({}, this.form);
            if (this.date && this.date.length) {
                form.createdAtStart = this.date[0];
                form.createdAtEnd = this.date[1];
            }
            if (form.statusCode) {
                form.prepayStatusCode = form.statusCode;
                delete form.statusCode;
            }
            this.loading = true;
            API.get(`contract/prepay/pages?page=${this.pagination.page}`, {
                params: form,
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                const msg = `${this.$t('Charge.search')}：
                    ${this.$t('Charge.all')}${res.totalElements}
                    ${this.$t('Charge.count')}`;
                this.$emit('input', msg);
            }).finally(() => this.loading = false);
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        handleSelectChange(val) {
            this.contracts = val;
            this.$emit('headListen', this.contracts);
        },
        validSelect() {
            if (this.contracts.length > 1)
                $ele.$message.warning(this.$t('Message.member_recode'));
            else if (this.contracts.length < 1)
                $ele.$message.warning(this.$t('Message.member_recode_choose'));
            else return true;
        },
        // 入会&续会
        async joinClub(type) {
            this.type = type;
            if (this.validSelect()) {
                let code;
                await API.get(`client/${this.contracts[0].clientId}`).then(res => {
                    code = res.typeCode;
                });
                if (type === 1 && code === 2)
                    $ele.$message(this.$t('Message.enter_tip'));
                else if (type === 2 && code === 1)
                    $ele.$message(this.$t('Message.xu_tip'));
                else this.$refs.mspContract.open(this.contracts[0].clientId, type, this.contracts[0].contractNum);
            }
        },
        // 买私教&买储值卡
        addCard(name, type) {
            if (this.validSelect()) {
                this.contract.name = name;
                this.client = this.contracts[0].clientId;
                this.num = this.contracts[0].contractNum;
                this.infoType = type;
                this.visible = true;
            }
        },
        handleCharge(type) {
            if (this.validSelect()) {
                if (type === 'money')
                    this.$refs.monday.open(this.contracts[0], type);
                else if (type === 'day' && this.$$filterPermission('售卖-定金合同管理-定金延期'))
                    this.$refs.monday.open(this.contracts[0], type);
                else if (type === 'day' && !this.$$filterPermission('售卖-定金合同管理-定金延期')) {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
    },
};
</script>
<style lang="scss">
.task-workers {
    color: #409EFF;
}
.task-status{
    color: #2a9546;
}
</style>
